import React from 'react';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const SecurityInfoSkeleton = () => {
  return (
    <div className={style.securityInfoSkeleton}>
      <SkeletonBlock className={style.skeletonText} />
      <SkeletonBlock className={style.skeletonText} />
    </div>
  );
};

export default SecurityInfoSkeleton;
